import React, { Fragment, useEffect, useState } from "react";
import {
  Box,
  Grid,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import styles from "./Cart.module.css";
import DeleteIcon from "@mui/icons-material/Delete";
import SettingsIcon from "@mui/icons-material/Settings";
import { Link } from "react-router-dom";
import Parse from "../../API/ParseServer";
const OrderArtworkItem: React.FC<{
  item: any;
}> = (props) => {
  const artwork = props.item.artwork;

  return (
    <TableRow
      key={props.item.objectId}
      sx={{
        "&:last-child td, &:last-child th": { border: 0 },
      }}
    >
      <TableCell component="th" scope="row">
        {artwork.get("thumbnail") ? (
          <img
            src={artwork.get("thumbnail").url()}
            alt={artwork.get("title")}
            style={{ width: "50px" }}
          />
        ) : (
          <Box
            sx={{
              width: "2rem",
              aspectRatio: 1,
              backgroundColor: "gray",
            }}
          ></Box>
        )}
      </TableCell>
      <TableCell align="center"> {props.item.title}</TableCell>

      <TableCell align="center">
        {artwork.get("width")} x {artwork.get("height")} cm
      </TableCell>
      <TableCell align="center">{props.item.quantity}</TableCell>
      <TableCell align="center"> £{props.item.price}</TableCell>
    </TableRow>
  );
};

export default OrderArtworkItem;
